@if (pannelPosition == 1) {
<div #panelRoot>
    <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: tasksList, accordionIdPrefix: 'nav-accordion-' + pannelPosition }">
    </ng-container>
</div>
}

<ng-template #recursiveListTmpl let-list="list" let-accordionIdPrefix="accordionIdPrefix">
    <ap-accordion-group #accordionGroup [multiple]="true" [accordionId]="accordionIdPrefix"
        [styleClass]="'nav-accordion-group'">
        @for (task of list; track trackByTaskId(i, task); let i = $index) {

            <ap-accordion
                [id]="'accordion-' + task.id"
                [title]="task.label"
                [styleClass]="getAccordionStyleClass(task)"
                (onClick)="onAccordionClick(task)">
                <div class="accordion-body-content" (click)="$event.stopPropagation()">
                    @if (task['children'] && task.children.length > 0) {
<div class="sub-gray-container"
                       >
                        <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: task.children, accordionIdPrefix: accordionIdPrefix + '-' + getTaskAccordionKey(task, i) }">
                        </ng-container>
                    </div>
}
                    @if (task['screens'] && mSetting.showScreen) {
<div>
                        <gtw-activity-and-screen [selected_menu]='task.screens'
                            (showScreensEvent)="showScreens($event)">
                        </gtw-activity-and-screen>
                    </div>
}
                </div>
            </ap-accordion>
        
}
    </ap-accordion-group>
</ng-template>


@if (pannelPosition != 1) {
<div #panelRoot>
    <ap-accordion-group #accordionGroup [multiple]="true" [accordionId]="'nav-category-accordion-' + pannelPosition"
        [styleClass]="'nav-accordion-group'">
        @for (category of tasksList; track trackByTaskId($index, category)) {

            @if (category.id >= 0 && category['children']) {
<ap-accordion
                [id]="'category-' + category.id"
                [title]="category.label"
                (onClick)="onAccordionClick(category)">
                <div (click)="$event.stopPropagation()">
                    <gtw-activity-and-screen [selected_menu]='category.children'
                        (showScreensEvent)="showScreens($event)">
                    </gtw-activity-and-screen>
                </div>
            </ap-accordion>
}
        
}
    </ap-accordion-group>
</div>
}
